// src/com/bulk_products/BulkProductsGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * BULK_PRODUCTS Apollo Graphql
 * Bulk Products
 * Project: NewTOP for cloud
 * 2026-05-14 13:44:32 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

const BULK_PRODUCTS_LIST_PART = gql`
fragment BulkProductsListPart on BulkProducts {
    bulkProductsId
    prodName
    useYn
    regDate
    regUser
    updatedDate
    updatedUser
    regUserName
}
`;

export const LIST_BULK_PRODUCTS = gql`
${BULK_PRODUCTS_LIST_PART}
query ListBulkProducts {
    bulkProductsList {
        ...BulkProductsListPart
    }
}
`;

export const GET_BULK_PRODUCTS = gql`
${BULK_PRODUCTS_LIST_PART}
query GetBulkProducts($bulkProductsId:Int!) {
    bulkProductsItem(bulkProductsId:$bulkProductsId) {
        ...BulkProductsListPart
    }
}
`;

export const ADD_BULK_PRODUCTS = gql`
mutation AddBulkProducts($bulkProducts:InputBulkProductsAdd!) {
	bulkProductsAdd(bulkProducts: $bulkProducts) {
		ok
		message
	}
}
`;

export const EDIT_BULK_PRODUCTS = gql`
mutation EditBulkProducts($bulkProducts:InputBulkProductsEdit!) {
	bulkProductsEdit(bulkProducts: $bulkProducts) {
		ok
		message
	}
}
`;

export const REMOVE_BULK_PRODUCTS = gql`
mutation RemoveBulkProducts($bulkProducts:InputBulkProductsRemove!) {
	bulkProductsRemove(bulkProducts: $bulkProducts) {
		ok
		message
	}
}
`;

export const SET_USAGE_BULK_PRODUCTS = gql`
mutation SetUsageBulkProducts($bulkProducts:InputBulkProductsSetUsage!) {
	bulkProductsSetUsage(bulkProducts: $bulkProducts) {
		ok
		message
	}
}
`;

/**
 * 프로덕트 관리용 목록에 주어진 bulkCompanyId에 해당되는 상품과 그렇지 않은 상품을 구분하여 출력하기 위해
 * BULK_COMPANY_PRODUCTS 데이터를 참조하여 새로운 목록을 만들어야 함.
 * @param {*} productList 
 * @param {*} comProdList 
 * @param {*} bulkCompanyId 
 * @param {*} comName
 */
export function productListReflectCompanyRelation(productList, comProdList, bulkCompanyId, comName) {
    const comProdMap = {};
    comProdList.forEach(item => {
        if(item.bulkCompanyId === bulkCompanyId) {
            comProdMap[item.bulkProductsId] = true;
        }
    });

    return productList.map(item => {
        const owned = comProdMap[item.bulkProductsId] ? true : false;
        return {
            ...item,
            comName: owned ? comName : '-',
            owned: owned, // to filter later.
        }
    });
}